<template>
    <div>
        <multi-select
            ref="select"
            v-model="selected"
            :options="computedOptions"
            :multiple="multiple"
            :disabled="isDisabled"
            :searchable="searchable"
            :placeholder="computedPlaceholder"
            :label="selectLabel"
            :allow-empty="!required"
            :track-by="trackBy()"
            :taggable="tag"
            :close-on-select="!multiple"
            @input="singleInputChange"
            @close="multipleInputChange"
            @remove="remove"
        />
        <input type="hidden" :name="name" ref="input" />
        <input
            type="hidden"
            :name="extraField"
            ref="extra_fields"
            v-for="extraField in extraFields"
        />
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import MultiSelect from "vue-multiselect";
import {useDebugStore} from "../../stores/debug";

export default {
    components: { MultiSelect },
    props: {
        url: {
            type: String,
            default: () => "",
        },
        value: {
            default: () => null,
        },
        searchable: {
            type: Boolean,
            default: () => true,
        },
        multiple: {
            type: Boolean,
            default: () => false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        trackByOption: {
            type: String,
            default: () => "id",
        },
        placeholder: {
            type: String,
        },
        selectLabel: {
            type: String,
            default: () => "name",
        },
        tag: {
            type: Boolean,
            default: () => false,
        },
        required: {
            default: () => false,
            type: Boolean,
        },
        name: {
            type: String,
            default: () => "",
        },
        index: {
            type: Number,
            default: () => 0,
        },
        subIndex: {
            type: Number,
            default: () => null,
        },
        extraFields: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            selected: null,
            modified: false,
            loaded: false,
            isDisabled: false,
            startSortIndex: null,
            endSortIndex: null,
            debugStore: useDebugStore(),
        };
    },
    computed: {
        computedOptions() {
            if (this.debugStore.debugMode) {
                return this.options.map((option) => {
                    option = {...option};
                    option[this.selectLabel] = `[ID: ${option[this.trackByOption]}] ${option[this.selectLabel]}`;
                    return option;
                });
            }
            return this.options;
        },
        computedValue() {
            if (this.debugStore.debugMode && this.value) {
                if(!this.multiple || !Array.isArray(this.value)) {
                    let val = {...this.value};
                    val[this.selectLabel] = `[ID: ${val[this.trackByOption]}] ${val[this.selectLabel]}`;
                    return val;
                }
                if (Array.isArray(this.value) && this.value.length) {
                    return this.value.map(option => {
                        if (typeof (option) === "object") {
                            option = {...option};
                            option[this.selectLabel] = `[ID: ${option[this.trackByOption]}] ${option[this.selectLabel]}`;
                        }
                        return option;
                    });
                }
            }
            return this.value;
        },
        computedPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }
            return this.multiple
                ? "Select one or multiple options"
                : "Select an option";
        },
    },
    mounted() {
        this.selected = this.replaceIdsWithObjects();
        if (this.disabled) {
            this.isDisabled = this.disabled;
        }
        this.inputChange(this.value);
    },
    methods: {
        replaceIdsWithObjects(){
            if(typeof(this.value) === "number"){
                return this.computedOptions.filter(item => item.id === this.value)
            }
            if(!this.value || !this.multiple || !this.value.length) return this.computedValue;
            return this.computedValue.map(option => {
                if(typeof(option) === "object"){
                    return option;
                } else {
                    return this.computedOptions.filter(item => item.id === option)[0]
                }

            })
        },
        trackBy() {
            return this.trackByOption;
        },
        singleInputChange(value) {
            if (!this.multiple) this.inputChange(value);
        },
        multipleInputChange(value) {
            if (this.multiple) this.inputChange(value);
        },
        checkValue(value, field = this.trackBy()) {
            let text = "";
            if (Array.isArray(value)) {
                // multiple
                text = value.map((item) => item[field]);
                if(value.length && Number.isInteger(value[0])){
                    text = value
                }
            } else if (_.isObject(value)) {
                text = value[field];
            } else {
                text = value;
            }
            return text;
        },
        inputChange(value) {
            let text = "";
            if (value) {
                text = this.checkValue(value);
                this.$refs.input.value = text;

                this.extraFields.forEach((field, index) => {
                    this.$refs.extra_fields[index].value = this.checkValue(
                        value,
                        field
                    );
                });
            }

            if (!value && !this.required && !this.multiple) {
                this.$refs.input.value = null;
            }

            this.$emit(
                "sync",
                text,
                this.$attrs.id,
                value,
                this,
                this.index,
                this.subIndex
            );
        },
        remove(value) {
            if (!this.$refs.select.isOpen && this.multiple) {
                const newSelected = [];
                this.selected.forEach((selected) => {
                    if (selected[this.trackBy()] !== value[this.trackBy()])
                        newSelected.push(selected);
                });
                this.inputChange(newSelected);
            }
        },
    },
    watch: {
        value: function (value) {
            this.selected = this.replaceIdsWithObjects();
        },
        "debugStore.debugMode": function (value) {
            this.selected = this.replaceIdsWithObjects();
        },
    },
};
</script>
